// extracted by mini-css-extract-plugin
export default {"pages":"Paginator_pages__MC2Ml","selectedPage":"Paginator_selectedPage__dLcO7"};